/* unplugin-vue-components disabled */import script from "./codeNav.vue?vue&type=script&setup=true&lang=js"
export * from "./codeNav.vue?vue&type=script&setup=true&lang=js"

import "./codeNav.vue?vue&type=style&index=0&id=5a695e4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a695e4c"]])

export default __exports__